import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { CardError, Loading, CardListTurnHours } from '../../components';
import { getHoursDates } from '../../redux/actions/turnActions';
import 'moment/locale/es';

const HoursTurn = () => {
  const dispatch = useDispatch();
  const {
    dateTurnSelected, hoursTurn, isLoading
  } = useSelector((state) => state.turnReducer);
  const { healthInsurance } = useSelector((state) => state.healthInsuranceReducer);
  const { doctor } = useSelector((state) => state.doctorReducer);

  const fecha = moment(dateTurnSelected.fecha).locale('es').format(' D[/]M ');

  useEffect(() => {
    dispatch(getHoursDates(dateTurnSelected.fecha, healthInsurance.id, doctor.id));
  }, []);

  if (isLoading) return <Loading />;

  if (hoursTurn.length === 0) {
    return <CardError text="No hay horarios disponibles" />;
  }
  return (
    <CardListTurnHours data={hoursTurn} title={`Turnos para el ${fecha}`} type="hour" />
  );
};

export default HoursTurn;
